import React from 'react'
import style from "../Content.module.css";
import {Image, Button, Form, Input, message, Modal, Select, Space, Table} from "antd";
import Util from "../../../utils/utils";
import Axios from "../../../utils/axios";
import {ExclamationCircleOutlined} from "@ant-design/icons";
import PATH_URL from "../../../utils/url";

const {TextArea} = Input;

class TeamMembersInfo extends React.Component {
    addFormRef = React.createRef();
    viewFormRef = React.createRef();
    editFormRef = React.createRef();
    state = {
        data: null,
        userName: null,
        realName: null,
        groupName: null,
        status: null,
        loading: true,
        current: 1,
        pageSize: 10,
        total: 0,
        addVisible: false,
        viewVisible: false,
        editVisible: false,
        qrCodeVisible: false,
        qrCodeImage: null,
    }

    componentDidMount() {
        let userName = JSON.parse(window.sessionStorage.getItem("userName"));
        if (!Util.isEmpty(userName)) {
            this.initData();
        }
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return
        }
    }

    initData = () => {
        Axios({
            method: 'get',
            url: '/user/listUser',
            params: {
                userName: this.state.userName,
                realName: this.state.realName,
                groupName: this.state.groupName,
                invitationUser: JSON.parse(window.sessionStorage.getItem("userName")),
                role: 6,
                status: this.state.status,
                pageNum: this.state.current,
                pageSize: this.state.pageSize
            }
        }).then(res => {
            if (res.status === 200) {
                if (res.data.code === 200) {
                    this.setState({
                        data: res.data.data.list,
                        loading: false,
                        total: res.data.data.total,
                    });
                } else {
                    this.setState({
                        loading: false,
                    });
                    message.error(res.data.message);
                }
            } else if (res.code === 401) {
                this.setState({
                    loading: false,
                });
                message.error(res.message);
            }
        }).catch(err => {
            this.setState({
                loading: false,
            });
            console.log(err);
        });
    }
    inputChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        }, () => {
            this.searchUser();
        });
    }
    statusChange = (value) => {
        this.setState({
            status: value,
        }, () => {
            this.searchUser();
        })
    }
    searchUser = () => {
        this.setState({
            loading: true,
        });
        this.initData();
    }
    resetSearch = () => {
        this.setState({
            userName: null,
            realName: null,
            groupName: null,
            status: null,
        });
    }
    handleCancel = () => {
        this.setState({
            viewVisible: false,
            editVisible: false,
            addVisible: false,
            qrCodeVisible: false,
        });
    }
    showAddUser = () => {
        this.setState({
            addVisible: true,
        });
    }
    addUser = () => {
        this.addFormRef.current.validateFields().then(values => {
            values.invitationUser = JSON.parse(window.sessionStorage.getItem("userName"));
            values.role = 6;
            Axios({
                method: 'post',
                url: '/user/register',
                data: JSON.stringify(values)
            }).then(res => {
                if (res.status === 200) {
                    if (res.data.code === 200) {
                        this.setState({
                            loading: true,
                            addVisible: false,
                        });
                        this.initData();
                        this.addFormRef.current.resetFields();
                        message.success(res.data.message);
                    } else {
                        message.error(res.data.message);
                    }
                } else if (res.code === 401) {
                    message.error(res.message);
                }
            }).catch(err => {
                console.log(err);
            });
        }).catch(info => {
            console.log(info);
        });
    }
    updateUser = () => {
        this.editFormRef.current.validateFields().then(values => {
            Axios({
                method: 'post',
                url: '/user/updateUser',
                data: JSON.stringify(values)
            }).then(res => {
                if (res.status === 200) {
                    if (res.data.code === 200) {
                        this.setState({
                            loading: true,
                            editVisible: false,
                        });
                        this.initData();
                        this.editFormRef.current.resetFields();
                        message.success(res.data.message);
                    } else {
                        message.error(res.data.message);
                    }
                } else if (res.code === 401) {
                    message.error(res.message);
                }
            }).catch(err => {
                console.log(err);
            });
        }).catch(info => {
            console.log(info);
        });
    }
    showUserInfo = (record) => {
        this.setState({
            viewVisible: true,
        });
        // 设置100毫秒的延迟 确保from组件已经加载完毕
        setTimeout(() => {
            this.viewFormRef.current.setFieldsValue(record);
        }, 100);
    }
    showEditUser = (record) => {
        this.setState({
            editVisible: true,
        });
        // 设置100毫秒的延迟 确保from组件已经加载完毕
        setTimeout(() => {
            this.editFormRef.current.setFieldsValue(record);
        }, 100);
    }
    showResetPassword = (record) => {
        Modal.confirm({
            icon: <ExclamationCircleOutlined/>,
            content: "确认重置该用户密码？重置密码为123456",
            onOk: () => {
                Axios({
                    method: 'put',
                    url: '/user/resetPassword/' + record.id,
                    params: {}
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data.code === 200) {
                            message.success(res.data.message);
                            this.initData();
                        } else {
                            message.error(res.data.message);
                        }
                    } else if (res.code === 401) {
                        message.error(res.message);
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            onCancel: () => {

            },
        });
    }
    showChangeUserStatus = (record, status) => {
        Modal.confirm({
            icon: <ExclamationCircleOutlined/>,
            content: "确认" + (status === 0 ? "启用" : "禁用") + "该用户？",
            onOk: () => {
                Axios({
                    method: 'put',
                    url: '/user/changeUserStatus/' + record.id,
                    params: {
                        status: status,
                    }
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data.code === 200) {
                            message.success(res.data.message);
                            this.initData();
                        } else {
                            message.error(res.data.message);
                        }
                    } else if (res.code === 401) {
                        message.error(res.message);
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            onCancel: () => {

            },
        });
    }
    showDeleteUser = (record) => {
        Modal.confirm({
            icon: <ExclamationCircleOutlined/>,
            content: "确认删除该用户？",
            onOk: () => {
                Axios({
                    method: 'delete',
                    url: '/user/deleteUser/' + record.id,
                    params: {}
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data.code === 200) {
                            message.success(res.data.message);
                            this.initData();
                        } else {
                            message.error(res.data.message);
                        }
                    } else if (res.code === 401) {
                        message.error(res.message);
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            onCancel: () => {

            },
        });
    }
    showQRCode = (record) => {
        Axios({
            method: 'get',
            url: PATH_URL.BASE_URL + "/" + PATH_URL.TEAM_MEMBERS_QR_CODE_URL + "/" + record.userName,
        }).then(res => {
            if (res.data != null) {
                this.setState({
                    qrCodeVisible: true,
                    qrCodeImage: res.data,
                });
            }
        }).catch(err => {
            console.log(err);
        });
    }

    render() {
        const layout = {
            labelCol: {span: 5},
            wrapperCol: {span: 19},
        };
        const columns = [
            {
                title: '账户',
                dataIndex: 'userName',
                key: 'userName',
            },
            {
                title: '组名',
                dataIndex: 'groupName',
                key: 'groupName',
            },
            {
                title: '组员姓名',
                dataIndex: 'realName',
                key: 'realName',
            },
            {
                title: '电话',
                dataIndex: 'tel',
                key: 'tel',
            },
            {
                title: '状态',
                dataIndex: 'status',
                key: 'status',
                render: status => {
                    switch (status) {
                        case 0:
                            return '启用中';
                        case 1:
                            return '禁用中';
                        default:
                            return '启用中';
                    }
                }
            },
            {
                title: '备注',
                dataIndex: 'remarks',
                key: 'remarks',
                ellipsis: true,
            },
            {
                title: '创建时间',
                dataIndex: 'gmtCreate',
                key: 'gmtCreate',
                width: 170,
            },
            {
                title: '操作',
                key: 'action',
                fixed: 'right',
                width: 260,
                render: (text, record) => (
                    <Space size="small">
                        <a onClick={this.showUserInfo.bind(this, record)}>查看</a>
                        <a onClick={this.showEditUser.bind(this, record)}>修改</a>
                        <a onClick={this.showResetPassword.bind(this, record)}>重置密码</a>
                        {
                            record.status === 0 ? (
                                <a style={{'color': '#f5ce0a'}}
                                   onClick={this.showChangeUserStatus.bind(this, record, 1)}>禁用</a>) : (
                                <a style={{'color': '#f5ce0a'}}
                                   onClick={this.showChangeUserStatus.bind(this, record, 0)}>启用</a>)
                        }
                        {/*<a style={{'color': '#d43f3a'}}*/}
                        {/*   onClick={this.showDeleteUser.bind(this, record)}>删除</a>*/}
                        <a onClick={this.showQRCode.bind(this, record)}>获取二维码</a>
                    </Space>
                ),
            },
        ];
        return (
            <div className={style['content']} id='content'>
                <div className={style['content_info']}>
                    <Form layout='inline'>
                        <Form.Item
                            label="账户"
                            name="userName"
                            style={{width: 200, marginTop: '5px', marginBottom: '5px'}}>
                            <Input placeholder="请输入账户"
                                   style={{width: '85%'}}
                                   onChange={this.inputChange}/>
                        </Form.Item>

                        <Form.Item
                            label="组名"
                            name="groupName"
                            style={{width: 200, marginTop: '5px', marginBottom: '5px'}}>
                            <Input placeholder="请输入组名"
                                   style={{width: '85%'}}
                                   onChange={this.inputChange}/>
                        </Form.Item>
                        <Form.Item
                            label="组员姓名"
                            name="realName"
                            style={{width: 200, marginTop: '5px', marginBottom: '5px'}}>
                            <Input placeholder="请输入姓名"
                                   style={{width: '85%'}}
                                   onChange={this.inputChange}/>
                        </Form.Item>
                        <Form.Item
                            label="状态"
                            name="status"
                            style={{width: 130, marginTop: '5px', marginBottom: '5px'}}>
                            <Select style={{width: '85%'}} onChange={this.statusChange}>
                                <Select.Option value="0">启用中</Select.Option>
                                <Select.Option value="1">禁用中</Select.Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            style={{marginTop: '5px', marginBottom: '5px'}}>
                            <Button type="primary" onClick={this.searchUser}>查询</Button>
                            <Button type="primary" htmlType="reset" style={{'marginLeft': '5px'}}
                                    onClick={this.resetSearch}>重置</Button>
                            <Button type="primary" style={{'marginLeft': '5px'}}
                                    onClick={this.showAddUser}>添加</Button>
                        </Form.Item>
                    </Form>
                    <Modal
                        title={
                            <div
                                style={{
                                    width: '100%',
                                    cursor: 'move',
                                }}>
                                新增
                            </div>
                        }
                        visible={this.state.addVisible}
                        onOk={this.addUser}
                        onCancel={this.handleCancel}>
                        <Form {...layout}
                              ref={this.addFormRef}>
                            <Form.Item
                                label="账户"
                                name="userName"
                                rules={[{
                                    validator: async (_, value, callback) => {
                                        if (Util.isTel(value)) {
                                            return Promise.resolve()
                                        } else {
                                            return Promise.reject('请输入正确的手机号码');
                                        }
                                    }
                                }]}>
                                <Input/>
                            </Form.Item>
                            <Form.Item
                                label="组名"
                                name="groupName"
                                rules={[{required: true, message: '请输入组名'}]}>
                                <Input/>
                            </Form.Item>
                            <Form.Item
                                label="姓名"
                                name="realName"
                                rules={[{required: true, message: '请输入姓名'}]}>
                                <Input/>
                            </Form.Item>
                        </Form>
                    </Modal>
                    <Modal
                        title={
                            <div
                                style={{
                                    width: '100%',
                                    cursor: 'move',
                                }}>
                                查看
                            </div>
                        }
                        visible={this.state.viewVisible}
                        onOk={this.handleCancel}
                        onCancel={this.handleCancel}>
                        <Form {...layout}
                              ref={this.viewFormRef}>
                            <Form.Item
                                label="账户"
                                name="userName">
                                <Input disabled/>
                            </Form.Item>
                            <Form.Item
                                label="姓名"
                                name="realName">
                                <Input disabled/>
                            </Form.Item>
                            <Form.Item
                                label="组名"
                                name="groupName">
                                <Input disabled/>
                            </Form.Item>
                            <Form.Item
                                label="电话"
                                name="tel">
                                <Input disabled/>
                            </Form.Item>
                            <Form.Item
                                label="身份证"
                                name="idCard">
                                <Input disabled/>
                            </Form.Item>
                            <Form.Item
                                label="收货地址"
                                name="address">
                                <Input disabled/>
                            </Form.Item>
                            <Form.Item
                                label="备注"
                                name="remarks">
                                <TextArea disabled rows={4}/>
                            </Form.Item>
                        </Form>
                    </Modal>
                    <Modal
                        title={
                            <div
                                style={{
                                    width: '100%',
                                    cursor: 'move',
                                }}>
                                修改
                            </div>
                        }
                        visible={this.state.editVisible}
                        onOk={this.updateUser}
                        onCancel={this.handleCancel}>
                        <Form {...layout}
                              ref={this.editFormRef}>
                            <Form.Item
                                label="账户"
                                name="userName">
                                <Input disabled/>
                            </Form.Item>
                            <Form.Item
                                label="姓名"
                                name="realName">
                                <Input/>
                            </Form.Item>
                            <Form.Item
                                label="组名"
                                name="groupName">
                                <Input/>
                            </Form.Item>
                            <Form.Item
                                label="电话"
                                name="tel"
                                rules={[{
                                    validator: async (_, value, callback) => {
                                        if (Util.isTel(value)) {
                                            return Promise.resolve()
                                        } else {
                                            return Promise.reject('请输入正确的手机号码');
                                        }
                                    }
                                }]}>
                                <Input/>
                            </Form.Item>
                            <Form.Item
                                label="身份证"
                                name="idCard"
                                rules={[{
                                    validator: async (_, value) => {
                                        if (Util.isEmpty(value)) {
                                            return true;
                                        } else {
                                            if (Util.isIdCard(value)) {
                                                return Promise.resolve()
                                            } else {
                                                return Promise.reject('请输入正确的身份证号');
                                            }
                                        }
                                    }
                                }]}>
                                <Input/>
                            </Form.Item>
                            <Form.Item
                                label="收货地址"
                                name="address">
                                <Input/>
                            </Form.Item>
                            <Form.Item
                                label="备注"
                                name="remarks">
                                <TextArea rows={4}/>
                            </Form.Item>
                        </Form>
                    </Modal>
                    <Modal
                        title={
                            <div
                                style={{
                                    width: '100%',
                                    cursor: 'move',
                                }}>
                                二维码
                            </div>
                        }
                        visible={this.state.qrCodeVisible}
                        onOk={this.handleCancel}
                        onCancel={this.handleCancel}>
                        <Form>
                            <Form.Item>
                                <Image
                                    width={470}
                                    height={450}
                                    fallback="data:image/png;base64,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"
                                    src={this.state.qrCodeImage}/>
                            </Form.Item>
                        </Form>
                    </Modal>
                    <Table columns={columns}
                           size="small"
                           dataSource={this.state.data}
                           rowKey={columns => columns.id}
                           loading={this.state.loading}
                           style={{'marginTop': '20px'}}
                           scroll={{x: 1500}}
                           pagination={{
                               showTotal: () => `共 ${this.state.total} 条`,
                               onShowSizeChange: (current, pageSize) => {
                                   this.setState({
                                       current: current,
                                       pageSize: pageSize
                                   });
                                   setTimeout(() => {
                                       this.initData();
                                   }, 100);
                               },
                               total: this.state.total,
                               current: this.state.current,
                               pageSize: this.state.pageSize,
                               onChange: (current, pageSize) => {
                                   this.setState({
                                       current: current,
                                       pageSize: pageSize
                                   });
                                   setTimeout(() => {
                                       this.initData();
                                   }, 100);
                               }
                           }}/>
                </div>
            </div>
        )
    }
}

export default TeamMembersInfo;